import { Box, Text, Image, Flex } from '@opendoor/bricks/core';
import imgixUrl from '../../helpers/imgixUrl';

export const isUnsupportedBrowser = () => {
  const ua = typeof window !== 'undefined' && window?.navigator?.userAgent;
  if (!ua) {
    return false;
  }
  const isIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
  if (isIE) {
    return true;
  }
  return false;
};

const UnsupportedBrowserBanner = () => {
  return (
    <Box backgroundColor="neutrals0" marginTop="55px" padding={5} paddingBottom={0}>
      <Flex alignItems="center">
        <Text fontWeight="bolder" lineHeight={[1.2, null, 1.45]}>
          <Image
            width={15}
            height={15}
            mr={2}
            mt="-3px"
            src={imgixUrl('9a25d01781814faa96db07ab94f7813e.png?w=15&h=15')}
            alt="Warning icon"
          />
          Opendoor no longer supports this browser. Please upgrade to a supported browser like{' '}
          <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge</a>,{' '}
          <a href="https://www.google.com/chrome/">Chrome</a> or{' '}
          <a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>.
        </Text>
      </Flex>
    </Box>
  );
};

export default UnsupportedBrowserBanner;
